import React from 'react'
import { CustomTitle } from 'src/components'
import { CheckOutlined } from '@ant-design/icons'
import styles from './SaleDocumentValid.module.scss'

interface SaleDocumentValidProps {
  title: string,
  label: string
}

const SaleDocumentValid: React.FC<SaleDocumentValidProps> = (props) => {

  return  <>
    <CustomTitle className={styles.title} label={props.title} />
    <CustomTitle type='success' label={<>
      <CheckOutlined color='#43CB6F' className='icon-inline' />
      {props.label}
    </>}/>
  </>
}

export default SaleDocumentValid
